import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { requirementService } from '../../services/requirementService';
import RequirementForm from '../../components/Requirements/RequirementForm';
import Toast from '../../components/Common/Toast';

const EditRequirement = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [requirement, setRequirement] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const load = async () => {
      try {
        const res = await requirementService.getRequirement(id);
        if (res.success) setRequirement(res.data);
        else navigate('/requirements');
      } catch {
        navigate('/requirements');
      } finally {
        setLoading(false);
      }
    };
    if (id) load();
  }, [id, navigate]);

  if (loading) {
    return (
      <div className="p-6 text-center text-gray-500">Cargando...</div>
    );
  }

  const readOnly = requirement?.status === 'cancelled';

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6 flex flex-wrap justify-between items-start gap-3">
          <div>
            <h1 className="text-3xl font-bold text-gray-800">
              {readOnly ? 'Ver requerimiento' : 'Editar requerimiento'}
            </h1>
            <p className="text-sm font-mono text-teal-600 mt-1">{requirement?.code}</p>
          </div>
          <button
            type="button"
            onClick={() => window.open(`/requirements/${id}/print`, '_blank')}
            className="inline-flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white text-gray-800 rounded-lg hover:bg-gray-50 text-sm font-medium"
            title="Imprimir requerimiento"
          >
            <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z"
              />
            </svg>
            Imprimir
          </button>
        </div>
        <RequirementForm
          isOpen={true}
          isPageMode={true}
          requirement={requirement}
          readOnly={readOnly}
          onClose={() => navigate('/requirements')}
          onSuccess={() => navigate('/requirements')}
        />
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditRequirement;


